import { useState } from 'react';

import type {
  UseSortParams,
  SortOption,
} from 'components/DealerPage/components/Sort/Sort.typed';

export const SORT_OPTIONS = [
  { value: '', displayName: 'Best match' },
  { value: 'publishdatedesc', displayName: 'Newest' },
  { value: 'publishdateasc', displayName: 'Oldest' },
  { value: 'pricedesc', displayName: 'Highest price' },
  { value: 'priceasc', displayName: 'Lowest price' },
];

const useSort = (params: UseSortParams) => {
  const { onChange, selected } = params;

  const [fallbackOption] = SORT_OPTIONS;

  const selectedValueDisplay =
    SORT_OPTIONS.find(({ value }) => value === selected)?.displayName ??
    fallbackOption.displayName;

  const [label, setLabel] = useState(selectedValueDisplay);

  const handleClickOption = (option: SortOption) => {
    onChange(option.value);
    setLabel(option.displayName);
  };

  const items = SORT_OPTIONS.map((option) => ({
    onClick: () => handleClickOption(option),
    displayName: option.displayName,
  }));

  const labelText = `Sort by: ${label}`;

  return {
    labelText,
    items,
  };
};

export { useSort };
